const state = {
  watermark: {
    clearWatermark: false
  },
  editing: false
};

const getters = {
  watermark: (state) => state.watermark,
  editing: (state) => state.editing
};

const mutations = {
  setClearWatermark(state, value) {
    state.watermark.clearWatermark = value;
  },
  setEditing(state, flag) {
    state.editing = flag;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
